import { render, staticRenderFns } from "./TabActivity.vue?vue&type=template&id=99b2238e&scoped=true&"
import script from "./TabActivity.vue?vue&type=script&lang=js&"
export * from "./TabActivity.vue?vue&type=script&lang=js&"
import style0 from "./TabActivity.vue?vue&type=style&index=0&id=99b2238e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b2238e",
  null
  
)

export default component.exports